( function ( _s ) {
	_s.fn.episodePlaylist = function () {
		return this.el.forEach( el => {
			const _episodePlaylist = _s( el );
			const _currentVideo = _episodePlaylist.find( '.current-video' );
			const _currentVideoIframe = _currentVideo.find( 'iframe' );
			const _currentVideoTitle = _currentVideo.find( '.video-title h5' );
			const _currentVideoDescription = _currentVideo.find( '.video-description' );
			const _playlistVideosContainer = _episodePlaylist.find( '.playlist-videos' );
			const _links = _playlistVideosContainer.find( '.playlist-video' );

			const listPadding = () => {
				const playlistVideosContainer = _playlistVideosContainer.firstElement();
				if ( playlistVideosContainer.scrollHeight > playlistVideosContainer.clientHeight ) {
					_playlistVideosContainer.addClass( 'has-scrollbar' );
				} else {
					_playlistVideosContainer.removeClass( 'has-scrollbar' );
				}
			};

			const scrollToVideo = () => {
				let offset = parseInt( window.getRootProperty( '--body-top-padding' ) ) + 50;
				window.scrollTo( 0, _currentVideoIframe.offset().top - offset );
			};

			const selectVideo = target => {
				const _target = _s( target );
				const _link = _target.hasClass( 'playlist-video' )
					? _target
					: _target.closest( '.playlist-video' );

				if ( _link.length ) {
					const videoInfo = JSON.parse( _link.attr( 'data-video-info' ) || {} );
					_links.removeClass( 'selected' );
					_link.addClass( 'selected' );

					/** update iframe */
					_currentVideoIframe.attr( 'title', videoInfo.title );
					_currentVideoIframe.attr(
						'src',
						`https://www.youtube.com/embed/${ videoInfo.video_id }?autoplay=1`
					);

					/** update title */
					_currentVideoTitle.attr( 'title', videoInfo.title );
					_currentVideoTitle.text( videoInfo.title );

					/** update description */
					if ( _currentVideoDescription.length ) {
						_currentVideoDescription.attr( 'title', videoInfo.description );
						_currentVideoDescription.text( videoInfo.description );
					}
				}
			};

			_links.on( 'click', e => {
				selectVideo( e.target );

				if ( [ 'xs', 'sm', 'md' ].includes( window.currentBreakpoint() ) ) {
					scrollToVideo();
				}
			} );

			_links.on( 'keyup', e => {
				if ( e.key === 'Enter' ) {
					selectVideo( e.target );
				}
			} );

			_s( window ).on( 'resize', () => {
				listPadding();
			} );

			listPadding();
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '.episode-playlist.module' );

		if ( _elements.length ) {
			_elements.episodePlaylist();
		}
	} );
} )( window._s );
